import { z } from "zod";
export const PublicAdsConfigSchema = z.object({
    mode: z.enum(["off", "preview", "live"]),
    publisher_id: z.string().regex(/^ca-pub-\d{16}$/).nullable(),
    guide_unit_id: z.string().regex(/^\d{1,20}$/).nullable(),
    cabinet_unit_id: z.string().regex(/^\d{1,20}$/).nullable(),
    guide_enabled: z.boolean(),
    cabinet_enabled: z.boolean()
}).strict();
export const ADS_OFF = { mode: "off", publisher_id: null, guide_unit_id: null, cabinet_unit_id: null, guide_enabled: false, cabinet_enabled: false };
